// extracted by mini-css-extract-plugin
export var cardButton = "style-mod--card-button--8fda8";
export var categoryContainer = "style-mod--category-container--d915d";
export var collectionColoredTitle = "style-mod--collection-colored-title--dee01";
export var collectionFilterSlider = "style-mod--collection-filter-slider--92310";
export var collectionTitle = "style-mod--collection-title--df25b";
export var content = "style-mod--content--a25e7";
export var prodImg = "style-mod--prod-img--96c39";
export var roundedCornerns = "style-mod--rounded-cornerns--96835";
export var roundedImagesCollection = "style-mod--rounded-images-collection--93efe";
export var sliderContainer = "style-mod--slider-container--a0154";
export var smallContainer = "style-mod--small-container--2cb71";